import { APPOINTMENT_STATUS_FOR_COVID_19_LABEL } from '../../constants';

function AppointmentListCtrl(
  ModalService,
  $rootScope,
  $routeParams,
  $q,
  $route,
  appointmentListsService,
  UtilService,
  FeedbackService,
  ErrorService,
  ToastService,
  $scope,
  $location,
) {
  const vm = this;

  vm.APPOINTMENT_STATUS_FOR_COVID_19_LABEL =
    APPOINTMENT_STATUS_FOR_COVID_19_LABEL;
  vm.page = 1;
  vm.listingId = $routeParams.listingId;
  vm.isCovidFlagEnabled = $rootScope.hasFeature('COVID_19');
  vm.appointmentsLoaded = false;
  vm.loadingMore = false;
  vm.limit = 20;
  vm.sortBy = 'time';
  vm.order = 'DESC';
  vm.listingLink = `#/listing/${$routeParams.listingId}/view`;
  vm.formatDate = date => moment(date, 'YYYY-MM-DD').format('ddd, MMM Do');
  vm.actionTab = 'inPersonShowing';
  vm.suggestedTimeChangePermission = [
    'new',
    'confirm',
    'time_change',
    'suggested_time_change',
    'attempted',
  ];

  vm.$onInit = () => {
    if ($routeParams.appointment && $routeParams.tab) {
      ModalService.openAppointmentModal(
        $routeParams.appointment,
        vm.listingId,
        $routeParams.tab,
      ).then(function (updated) {
        if (updated) $route.reload();
      });
    }
  };

  vm.$onInit = () => {
    if ($routeParams.appointment && $routeParams.tab) {
      ModalService.openAppointmentModal(
        $routeParams.appointment,
        vm.listingId,
        $routeParams.tab,
      ).then(function (updated) {
        if (updated) $route.reload();
      });
    }
  };

  const promises = [
    appointmentListsService.getListing(vm.listingId),
    appointmentListsService.getAppointments(
      vm.page,
      vm.limit,
      vm.listingId,
      `${vm.sortBy} ${vm.order}`,
    ),
    appointmentListsService.getPermission(vm.listingId),
    UtilService.getServerDate(),
    appointmentListsService.getVirtualTourCount(vm.listingId),
  ];

  $q.all(promises)
    .then(([listing, appointments, permission, { date }, virtualToursRes]) => {
      vm.serverDate = date;
      vm.listing = listing;
      vm.appointments = appointments.appointments;
      vm.appointments = vm.appointments.map(apt => ({
        ...apt,
        link: `#/appointments/${apt.id}/`,
      }));
      vm.virtualToursCount = virtualToursRes.total;
      vm.totalCount = appointments.totalCount;
      vm.permissions = permission;
      vm.auth = $rootScope.auth;
      vm.page += 1;
      vm.loadMoreAppointments = vm.page <= Math.ceil(vm.totalCount / vm.limit);
      const isListingAgent = vm.listing.reps.some(
        user => user.id === $rootScope.auth.id,
      );
      const isHiddenAgent =
        vm.listing.hiddenReps &&
        vm.listing.hiddenReps.some(user => user.id === $rootScope.auth.id);
      const isTeamAdmin =
        vm.auth.team &&
        vm.auth.role === 'TEAM_ADMIN' &&
        vm.listing.reps.some(
          rep => rep.team === vm.auth.team || vm.auth.teams?.includes(rep.team),
        );
      // determine can deny/can confirm
      if (isListingAgent || isHiddenAgent || isTeamAdmin) {
        vm.showButton = (appointmentId, buttonStatus) =>
          vm.permissions[appointmentId] &&
          vm.permissions[appointmentId][buttonStatus];
      }
      vm.appointmentsLoaded = true;

      vm.hasVSFeatureFlag = listing.org.features.includes('VIRTUAL_SHOWINGS');
    })
    .catch(err => {
      const { data } = err;
      $location.path(`/listing/${vm.listingId}/view`);
      if (data.type === 'FORBIDDEN_ACTION') {
        data.message =
          'You do not have permissions to view this page. Please contact support@brokerbay.com for more information.';
      }
      this.ErrorService.toastyHTTPErr({ ...err, data });
    });

  vm.sort = sortBy => {
    vm.sortBy = sortBy;
    vm.order = vm.order === 'DESC' ? 'ASC' : 'DESC';
    vm.page = 1;
    vm.loadMoreAppointments = vm.page <= Math.ceil(vm.totalCount / vm.limit);
    vm.appointments = [];
    vm.loadMore();
  };

  vm.setActionTab = key => {
    $scope.$apply(() => {
      vm.actionTab = key;
    });
  };

  vm.openPreviewToTab = function (appointmentId, tab) {
    ModalService.openAppointmentModal(appointmentId, vm.listingId, tab).then(
      function (updated) {
        if (updated) $route.reload();
      },
    );
  };

  // Open the preview modal to the feedback tab to easily send reminder
  vm.openPreviewToFeedback = function (appointmentId) {
    ModalService.openAppointmentModal(
      appointmentId,
      vm.listingId,
      'feedback',
    ).then(function (updated) {
      if (updated) $route.reload();
    });
  };

  // Load more appointments when scrolled to bottom;
  vm.loadMore = () => {
    if (vm.loadMoreAppointments && !vm.loadingMore) {
      vm.loadingMore = true;
      appointmentListsService
        .getAppointments(
          vm.page,
          vm.limit,
          vm.listingId,
          `${vm.sortBy} ${vm.order}`,
        )
        .then(res => {
          vm.page += 1;
          vm.loadMoreAppointments =
            vm.page <= Math.ceil(vm.totalCount / vm.limit);
          vm.appointments = vm.appointments.concat(res.appointments);
          vm.totalCount = res.totalCount;
          vm.appointments = vm.appointments.map(apt => ({
            ...apt,
            link: `#/appointments/${apt.id}/`,
          }));
        })
        .catch(ErrorService.toastyHTTPErr)
        .finally(() => {
          vm.loadingMore = false;
        });
    }
  };

  vm.sendReminder = appointmentId => {
    // Don't try to send more reminders if one is already sending
    if (vm.sendingReminder) return;

    const { listingId } = vm;
    vm.selectedAppointment = appointmentId;
    FeedbackService.sendFeedbackReminder(listingId, appointmentId)
      .then(function () {
        ToastService.add({
          message: 'Email sent!',
          type: 'success',
        });
      })
      .catch(function (err) {
        ErrorService.toastyHTTPErr(err);
      })
      .finally(function () {
        vm.selectedAppointment = '';
      });
  };
}
angular.module('bb.appointments').component('bbAppointmentList', {
  bindings: {},
  controller: AppointmentListCtrl,
  controllerAs: 'vm',
  template: require('./appointment_list.html'),
});

AppointmentListCtrl.$inject = [
  'ModalService',
  '$rootScope',
  '$routeParams',
  '$q',
  '$route',
  'appointmentListsService',
  'UtilService',
  'FeedbackService',
  'ErrorService',
  'ToastService',
  '$scope',
  '$location',
];
